/**
 * Qawaem ERP is Saudi-only (Arabic product). Legacy Origin/SITERP builds are removed.
 */
export function isSaudiBrand() {
  return true;
}

export default isSaudiBrand;
